import { cn } from '@/lib/utils';
import { DataTable, HeaderPage } from './components';

export const TransactionsPage = () => (
  <div className={cn(
    'flex flex-col space-y-3 pb-20',
    'animate__animated animate__fadeIn'
  )}>
    <HeaderPage />
    <DataTable />
  </div>
);

export default TransactionsPage;
